import { WEEK_DAYS, WeekdayT } from "../types/schedulerSettings.types";

export const plateRegex = /^[A-Z]{3}\d{4}$|^[A-Z]{3}\d[A-Z]\d{2}$/;

export const weekdaysArr: WeekdayT[] = [
  { enum: WEEK_DAYS.SUNDAY, nameBr: "Domingo" },
  { enum: WEEK_DAYS.MONDAY, nameBr: "Segunda" },
  { enum: WEEK_DAYS.TUESDAY, nameBr: "Terça" },
  { enum: WEEK_DAYS.WEDNESDAY, nameBr: "Quarta" },
  { enum: WEEK_DAYS.THURSDAY, nameBr: "Quinta" },
  { enum: WEEK_DAYS.FRIDAY, nameBr: "Sexta" },
  { enum: WEEK_DAYS.SATURDAY, nameBr: "Sábado" },
  { enum: WEEK_DAYS.HOLIDAY, nameBr: "Feriado" },
];